import { render, staticRenderFns } from "./AboutMeSnippet.vue?vue&type=template&id=8c0fe97c&scoped=true&"
import script from "./AboutMeSnippet.vue?vue&type=script&lang=js&"
export * from "./AboutMeSnippet.vue?vue&type=script&lang=js&"
import style0 from "./AboutMeSnippet.vue?vue&type=style&index=0&id=8c0fe97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0fe97c",
  null
  
)

export default component.exports